import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/appservice.service';
import { FileSaverService } from 'ngx-filesaver';
import * as _moment from 'moment';
import { Router } from '@angular/router';

const moment = _moment;
@Component({
  selector: 'app-report-home',
  templateUrl: './report-home.component.html',
  styleUrls: ['./report-home.component.css']
})
export class ReportHomeComponent implements OnInit {
  @ViewChild('myTable', { static: false }) table: any;

  rows = [
    { name: '', gender: '', company: '' },
    { name: '', gender: '', company: '' },
    { name: '', gender: '', company: '' },
  ];
  columns = [
    { prop: '' },
    { name: '' },
    { name: '' }
  ];
  selected = 'salessummary';
  selectedGroup = 'Date';
  selectedData = {
    value: 'salessummary',
    text: 'Invoice Details'
  };
  loadingIndicator = true;
  isGrouping = true;
  curdate = new Date();
  months = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  years = [this.curdate.getFullYear(), this.curdate.getFullYear() - 1, this.curdate.getFullYear() - 2,
  this.curdate.getFullYear() - 3, this.curdate.getFullYear() - 4, this.curdate.getFullYear() - 5];
  selectedmonth = this.months[0];
  selectedyear = this.years[0];
  selecteddate = this.getMonthDateRange(this.curdate.getFullYear(), this.curdate.getMonth() + 1);
  currentYear = moment().format('YYYY');
  lastYear = moment().subtract(1, 'year').format('YYYY');
  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'This Year': [moment().subtract(1, 'year').startOf('month'), moment().endOf('month')]
  };

  constructor(public translate: TranslateService, public service: AppService, private _FileSaverService: FileSaverService
    , private router: Router) {
    // this.selected = service.translate.instant('Report.Invoice');

    this.fetch((data) => {
      this.rows = data;
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });
    this.ranges['Year ' + this.currentYear] = [moment().startOf('year'), moment().endOf('year')];
    this.ranges['Year ' + this.lastYear] = [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')];
    if (!this.service.isadmin) {
      this.router.navigate(['/invoice/0']);
    }
  }

  ngOnInit() {

  }

  getMonthDateRange(year, month) {
    // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
    // array is 'year', 'month', 'day', etc
    const startDate = moment([year, month - 1]);

    // Clone the value before .endOf()
    const endDate = moment(startDate).endOf('month');

    // make sure to call toDate() for plain JavaScript date type
    console.log({ start: startDate, end: endDate });
    return { start: startDate, end: endDate };
  }

  getTotal(value) {
    let sum = 0;
    value.forEach(element => {
      sum += parseFloat(element['Grand Total']);
    });

    return sum;
  }

  toggleExpandGroup(group) {
    console.log('Toggled Expand Group!', group);
    this.table.groupHeader.toggleExpandGroup(group);
    return false;
  }

  onDetailToggle(event) {
    console.log('Detail Toggled', event);
  }

  ViewReport(event) {
    const target = event.source.selected._element.nativeElement;
    this.selectedData = {
      value: event.value,
      text: target.innerText.trim()
    };
    this.loadreport();
  }

  changeGrouping(event) {
    const target = event.source.selected._element.nativeElement;
    this.selectedGroup = event.value;
    this.loadreport();
  }

  DateSelected(event) {
    this.loadreport();
  }
  loadreport() {

    this.fetch((data) => {
      this.rows = data;
      if (this.selectedData.value === 'salessummary' || this.selectedData.value === 'salesitems') {
        if (this.selectedData.value === 'salesitems') {
          this.selectedGroup = 'Bill Number';
        } else {
          if (this.selectedGroup && this.selectedGroup === 'Bill Number') {
            this.selectedGroup = 'Date';
          }
        }
        this.isGrouping = true;
      } else {
        this.isGrouping = false;
      }
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });
  }
  downloadxls(type = 'xls') {
    this.service.getRequestXls('api/report/' + this.selected + '?type=' + type
      + '&start=' + this.selecteddate.start.format('YYYY-MM-DD HH:mm:ss')
      + '&end=' + this.selecteddate.end.format('YYYY-MM-DD HH:mm:ss'))
      .subscribe(data => {
        const fileName = type === 'xls' ? this.selectedData.text + '.xls' : type.replace('xls', '') + ' GSTR-1.xls';
        this._FileSaverService.save((<any>data), fileName);
      });
  }

  downloadgstr1() {
    this.service.getRequestXls('api/report/' + this.selected + '?type=gstr1&start=' + this.selecteddate.start.format('YYYY-MM-DD HH:mm:ss')
      + '&end=' + this.selecteddate.end.format('YYYY-MM-DD HH:mm:ss'))
      .subscribe(data => {
        const fileName = this.selectedData.text + '.json';
        this._FileSaverService.save((<any>data), fileName);
      });
  }

  fetch(cb) {

    this.service.getRequest('api/report/' + this.selected + '?start=' + this.selecteddate.start.format('YYYY-MM-DD HH:mm:ss')
      + '&end=' + this.selecteddate.end.format('YYYY-MM-DD HH:mm:ss'))
      .subscribe(data => {
        this.columns = [];
        for (const key in data[0]) {
          if (key.indexOf('demo') === -1) {
            this.columns.push({ prop: key });
          }
        }
        cb(data);
      });
  }

}
